import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    standalone: false
})
export class SearchBoxComponent implements OnInit,OnChanges, OnDestroy {
  @Input() width: number;
  @Input() searchedText: string;
  @Output() searchText = new EventEmitter<string>();
  private readonly ngUnsubscribe = new Subject<boolean>();
  @ViewChild('searchText', {static: true}) searchTextInput: ElementRef;
  text:string;
  constructor() {}

  ngOnInit() {
    if(this.searchedText!==undefined){
      this.text = this.searchedText;
    }
    fromEvent(this.searchTextInput.nativeElement, 'keyup')
      .pipe(
        takeUntil(this.ngUnsubscribe),
        distinctUntilChanged(),
        debounceTime(500),
        map((input: any) => input.target.value)
      )
      .subscribe(result => {
        this.searchText.emit(result);
      });
  }

  ngOnChanges() {
    if(this.searchedText!==undefined){
      this.text = this.searchedText;
    }

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
